import { baseMenuConfig } from './menuConfig'; // Use the static, unfiltered base config

/**
 * A recursive function to flatten the menu configuration into a list
 * that respects the hierarchy for display purposes.
 * @param {Array} config - The menu configuration array.
 * @param {number} level - The current depth in the hierarchy.
 * @returns {Array} A flat list of module objects with title and level.
 */
const flattenMenu = (config, level = 0) => {
    let modules = [];
    config.forEach(item => {
        // FIX: Use explicit module permission if available, otherwise fallback to title (uppercased)
        // This allows "Manifest Report" to have different IDs like 'MANIFEST REPORT' and 'PORT MANIFEST REPORT'
        const moduleKey = item.permission ? item.permission.module : item.title.toUpperCase();

        modules.push({
            title: item.title, // Keep original title for display
            module: moduleKey, // Unique ID for logic/DB
            level: level
        });

        // If there's a submenu, recurse into it
        if (item.submenu) {
            modules = modules.concat(flattenMenu(item.submenu, level + 1));
        }
    });
    return modules;
};

// Process the menu config to create a unique, hierarchical list of modules
const hierarchicalModules = flattenMenu(baseMenuConfig); 

// --- FIX: Export the list directly WITHOUT filtering duplicates ---
// This ensures that if 'MANIFEST REPORT' appears under both 'DOCUMENTATION' and 'PORT',
// it will appear in both places in the Permissions UI.
export const APP_MODULES_HIERARCHICAL = hierarchicalModules;